import template from './campus-edit-form.html';
import controller from './campus-edit-form-controller';

const CampusEditFormComponent = {
    bindings: {
        campus: '<',
        serviceList: '<',
        relatedModels: '<',
        updateTree: '&'
    },
    controller,
    template
};

export default CampusEditFormComponent;



// WEBPACK FOOTER //
// ./app/components/client-edit/campus-edit-form/campus-edit-form-component.js